export enum PipelinesPermissions {
  GET_PIPELINES_FOR_ACCOUNT = 'pipelines.getPipelinesForAccount',
  ADD_PIPELINE = 'pipelines.addPipeline',
  EDIT_PIPELINE = 'pipelines.editPipeline',
  DELETE_PIPELINE = 'pipelines.deletePipeline',
}
